
export default function useAvatarStats(items = [], avatar = null) {
  let equippedItems = items.filter((i) => i.isEquipped());

  // Take only one weapon into account
  const weapons = equippedItems.filter(i => i.getType() === 'weapon');
  if (weapons.length > 1) {
    const otherItems = equippedItems.filter(i => i.getType() !== 'weapon');
    const selectedWeapon = weapons.sort((a, b) => a.slot - b.slot)[0];
    equippedItems = [...otherItems, selectedWeapon];
  }
  let baseStats = {
    healthPoints: 0,
    attackPoints: 0,
    defencePoints: 0,
    speed: 0,
    criticalChance: 0
  }

  let modifiers = {
    healthPoints: 0,
    attackPoints: 0,
    defencePoints: 0,
    speedPoints: 0,
    criticalChancePoints: 0,
    healthMultiplier: 1.0,
    attackMultiplier: 1.0,
    defenceMultiplier: 1.0,
    speedMultiplier: 1.0,
    criticalChanceMultiplier: 1.0
  }

  let tempModifiers = {
    healthPoints: 0,
    attackPoints: 0,
    defencePoints: 0,
    speedPoints: 0,
    criticalChancePoints: 0,
    healthMultiplier: 1.0,
    attackMultiplier: 1.0,
    defenceMultiplier: 1.0,
    speedMultiplier: 1.0,
    criticalChanceMultiplier: 1.0
  }

  if (avatar) {
    baseStats = avatar.getBaselineStats();
    modifiers = avatar.getPermanentModifiers();
    tempModifiers = avatar.getTemporaryModifiers() || tempModifiers;
  }

  const calculatedHealthPoints = equippedItems.reduce((acc, item) => {
    return acc + item.getStats().healthPoints;
  }, modifiers.healthPoints);
  
  const calculatedAttackPoints = equippedItems.reduce((acc, item) => {
    return acc + item.getStats().attackPoints;
  }, modifiers.attackPoints);
  
  const calculatedDefencePoints = equippedItems.reduce((acc, item) => {
    return acc + item.getStats().defencePoints;
  }, modifiers.defencePoints);
  
  const calculatedSpeedPoints = equippedItems.reduce((acc, item) => {
    return acc + item.getStats().speedPoints;
  }, modifiers.speedPoints);
  
  const calculatedCriticalChancePoints = equippedItems.reduce((acc, item) => {
    return acc + item.getStats().criticalChancePoints;
  }, modifiers.criticalChancePoints);

  const calculatedHealthMultiplier = equippedItems.reduce((acc, item) => {
    return acc + (item.getStats().healthMultiplier - 1.0);
  }, modifiers.healthMultiplier - 1.0) + 1.0;
  
  const calculatedAttackMultiplier = equippedItems.reduce((acc, item) => {
    return acc + (item.getStats().attackMultiplier - 1.0);
  }, modifiers.attackMultiplier - 1.0) + 1.0;

  const calculatedDefenceMultiplier = equippedItems.reduce((acc, item) => {
    return acc + (item.getStats().defenceMultiplier - 1.0);
  }, modifiers.defenceMultiplier - 1.0) + 1.0;

  const calculatedSpeedMultiplier = equippedItems.reduce((acc, item) => {
    return acc + (item.getStats().speedMultiplier - 1.0);
  }, modifiers.speedMultiplier - 1.0) + 1.0;

  const calculatedCriticalChanceMultiplier = equippedItems.reduce((acc, item) => {
    return acc + (item.getStats().criticalChanceMultiplier - 1.0);
  }, modifiers.criticalChanceMultiplier - 1.0) + 1.0;

  const stats = {
    healthPoints: baseStats.healthPoints * calculatedHealthMultiplier + calculatedHealthPoints,
    attackPoints: baseStats.attackPoints * calculatedAttackMultiplier + calculatedAttackPoints,
    defencePoints: baseStats.defencePoints * calculatedDefenceMultiplier + calculatedDefencePoints,
    speed: baseStats.speed * calculatedSpeedMultiplier + calculatedSpeedPoints,
    criticalChance: baseStats.criticalChance * calculatedCriticalChanceMultiplier + calculatedCriticalChancePoints
  }

  return { stats, tempModifiers };
}

